module.exports = require("@seddi/three/examples/jsm/loaders/EXRLoader.js");